(function(doc, win, designWidth) {
    const html = doc.documentElement;
    const refreshRem = () => {
        const clientWidth = html.clientWidth; //拿到设备的宽
        if (clientWidth >= designWidth) {
            html.style.fontSize = '100px'; //如果超过设计稿的尺寸，就按照100px去算
        } else {
            //html.style.fontSize= 16 * clientWidth / 375 + 'px';
            html.style.fontSize = 100 * (clientWidth / designWidth) + 'px'; //不用/DPR了
        }
    };

    doc.addEventListener('DOMContentLoaded', refreshRem);
})(document, window, 750);